
function insightsAjax($page, $cat) {
	
	$current_page = window.location.href;
	$url = $current_page.split(/[?#]/)[0];
	
	if ($cat) {
		var $url = $url + '?paged=' + $page + '&cat=' + $cat;
	} else {
		var $url = $url + '?paged=' + $page;
	}

	var $load_more_btn = $('.load-more--insights');


	$.ajax({
        url:$url,
        success: function(response) {
            
            $items = $(response).find(".insights--posts_wrap .post-item");
            $numItems = $items.length;

            $(".insights--posts_wrap").append( $items );

            if ($numItems < 8) {
                $load_more_btn.hide();
            } else {
            	$load_more_btn.show();
            }
            
            $load_more_btn.removeClass('loading');
            $('.load-more-text').text('Load More');
            $('.insights--posts_wrap').removeClass('loading');
        }
    });
}
function insightsLoadMore() {
	
	// $(document).on('click', '.load-more--insights', function(e) {

	// 	e.preventDefault();

	// 	$(this).addClass('loading');
  //       $('.load-more-text').text('Loading...');

  //       $cat = ajax.cat;        
  //       ajax.page++
  //       insightsAjax(ajax.page, $cat);

	// });
}

function insightsCategory() {

	var $load_more_btn = $('.load-more--insights');

	$(document).on('click', '.insights--categories a', function(e) {
		
		e.preventDefault();

		if (!$(this).hasClass('active')) {

			$('.insights--categories a').removeClass('active');
			$(this).addClass('active');
			$('.insights--posts_wrap').empty().addClass('loading');

			
			$cat = $(this).data('cat');

			$current_cat = ajax.cat;

			ajax.cat = $(this).data('cat');

			if ($current_cat != $cat) {
				ajax.page = 1;
			} else {
				ajax.page++;
			}

			if ($cat == 'all') {
				ajax.page = 1;
				$cat = '';
			}

			insightsAjax(ajax.page, $cat);

		}

	});
}

insightsCategory()
insightsLoadMore()